export default "__VITE_ASSET__fOPr5K3W__"